
import { kbCategories } from '../../../mocks/knowledge-base';

interface KBSidebarProps {
  activeCategory: string;
  onCategoryChange: (id: string) => void;
  counts: Record<string, number>;
}

export default function KBSidebar({ activeCategory, onCategoryChange, counts }: KBSidebarProps) {
  return (
    <aside className="w-64 flex-shrink-0">
      <div className="sticky top-28 bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="px-5 py-4 border-b border-gray-100">
          <p className="font-heading font-semibold text-sm text-secondary uppercase tracking-wide">
            Browse Topics
          </p>
        </div>
        <nav className="p-3" aria-label="Knowledge base categories">
          {kbCategories.map((cat) => {
            const count = cat.id === 'all' ? counts.all : (counts[cat.id] ?? 0);
            const isActive = activeCategory === cat.id;
            return (
              <button
                key={cat.id}
                onClick={() => onCategoryChange(cat.id)}
                className={`w-full flex items-center justify-between px-4 py-3 rounded-xl mb-1 transition-all duration-200 cursor-pointer group ${
                  isActive
                    ? 'bg-primary/10 text-primary'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-secondary'
                }`}
                aria-current={isActive ? 'true' : undefined}
              >
                <div className="flex items-center gap-3">
                  <div className={`w-5 h-5 flex items-center justify-center ${isActive ? 'text-primary' : 'text-gray-400 group-hover:text-secondary'}`}>
                    <i className={`${cat.icon} text-base`} aria-hidden="true"></i>
                  </div>
                  <span className="font-body text-sm font-medium whitespace-nowrap">{cat.label}</span>
                </div>
                <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${
                  isActive ? 'bg-primary text-white' : 'bg-gray-100 text-gray-500'
                }`}>
                  {count}
                </span>
              </button>
            );
          })}
        </nav>

        {/* Quick Contact */}
        <div className="mx-3 mb-3 p-4 bg-gradient-to-br from-primary/10 to-secondary/10 rounded-xl">
          <p className="font-heading font-semibold text-sm text-secondary mb-1">Need help?</p>
          <p className="font-body text-xs text-gray-600 mb-3 leading-relaxed">
            Can't find what you're looking for? Our technical team is ready.
          </p>
          <a
            href="/contato"
            className="flex items-center gap-2 text-xs font-semibold text-primary hover:text-secondary transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-customer-service-2-line" aria-hidden="true"></i>
            Contact Support
          </a>
        </div>
      </div>
    </aside>
  );
}
